<template>
<div>
  <div class="full" style="display: flex; flex-direction: column;">
    <div style="flex: 1 auto">
      <div class="start-wrapper">
          <h2 class="start-title">create the now</h2>
          <div class="start-image">
            <img class="logo" src="../assets/imgs/camel-keyvisual.png" />
          </div>
          <div class="start-button">
            <b-button @click="onClickButton()" size="md" variant="primary">Jetzt starten</b-button>
          </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Home",
  methods: {
    onClickButton () {
      this.$emit('start')
    }
  }
}
</script>
<style lang="scss" scoped>
.full {
  height: 100vh;
  max-height: 100vh;
  padding-top: 72px;
  padding-bottom: 120px;
  max-width: 810px;
  margin-left: auto;
  margin-right: auto;
}
.start-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.start-title {
  max-width: 345px;
  font-size: 60px;
  font-weight: 700;
  line-height: 1;
  color: #00A3E0;
  text-align: center;
}
.start-image {
  max-width: 358px;
  transform: rotate(4deg);
  box-shadow: 2px 3px 8px 0 rgba(0,0,0,0.5);

  img {
    width: 100%;
  }
}
</style>
